import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash';

import {
  newCheckInAction,
  newNextAction,
} from '../../actions/navigation';
import ContentWrapper from '../../components/ContentWrapper';
import FormRow from '../../components/Form/FormRow';
import FormColumn from '../../components/Form/FormColumn';
import Card from '../../components/Card';
import Footer from '../../components/Footer';
import Pagination from '../../components/Pagination';
import Tooltip from '../../components/Tooltip';
import Button from '../../components/Button';
import Transition from '../../components/Transition';
import Progress from '../../components/Progress';
import ListView from '../../components/ListView';
import Headline from '../../components/Headline';

import FullLogo from '../../assets/images/logo-full.svg';
import { parseUrlParams, addLusaHeaderParam } from '../../utils/parseUrlParams';

const LuwaLanding = (props) => {
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [uploadingPercentage, setUploadingPercentage] = useState(0);
  const { checkinData, navigate } = props;
  const match = useParams();
  const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');

  useEffect(() => {
    const params = parseUrlParams(window.location.search);

    let data = {};
    if (params.test) {
      data = params.to
        ? {
          test: params.test,
          to: params.to,
        }
        : { test: params.test };
    } else {
      data = params.to
        ? { to: params.to }
        : {};
    }

    if (isEmpty(checkinData)) {
      props.newCheckInAction({
        workflowType,
        key: get(params, 'key'),
        data,
        success: (res) => {
          let routeUrl = get(res, 'data.url');
          if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
            routeUrl = addLusaHeaderParam(routeUrl);
          }
          navigate(routeUrl);
        },
      });
    }
  }, []);

  const handleNavigation = (e) => {
    e.preventDefault();
    const params = parseUrlParams(window.location.search);

    if (params.test) {
      props.newNextAction({
        workflowType,
        key: get(params, 'key'),
        data: {
          test: params.test,
        },
        onUploadProgress: (progressEvent) => {
          setIsProgressVisible(true);
          setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
        },
        success: (res) => {
          let routeUrl = get(res, 'data.url');
          if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
            routeUrl = addLusaHeaderParam(routeUrl);
          }
          navigate(routeUrl);
        },
      });
    } else {
      props.newNextAction({
        workflowType,
        key: get(params, 'key'),
        onUploadProgress: (progressEvent) => {
          setIsProgressVisible(true);
          setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
        },
        success: (res) => {
          let routeUrl = get(res, 'data.url');
          if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
            routeUrl = addLusaHeaderParam(routeUrl);
          }
          navigate(routeUrl);
        },
      });
    }
  };

  const renderHeader = () => (
    <ContentWrapper>
      <Headline
        image={FullLogo}
        header={(
          <>
            <span>
              Hi
              {get(props.checkinData, 'data.data.applicant.firstName')}
              !
            </span>
            Apply in
            {' '}
            <u>minutes</u>
            <br />
            Decisions in
            {' '}
            <u>seconds</u>
            .
            <br />
            Check your rate.
            <Tooltip>To check the rates you qualify for, LendingUSA does a soft credit pull that will not impact your credit score.</Tooltip>
          </>
        )}
      />
    </ContentWrapper>
  );

  return (
    <Transition className="transition-item wrapper landing">
      {renderHeader()}
      <Footer>
        <FormRow>
          <FormColumn>
            <Card title="Your Provider">
              <ListView
                data={[
                  <strong>{get(checkinData, 'data.data.provider.name')}</strong>,
                  get(checkinData, 'data.data.provider.streetAddress'),
                  `${get(checkinData, 'data.data.provider.city')}, ${get(checkinData, 'data.data.provider.state')} ${get(checkinData, 'data.data.provider.zip')}`,
                ]}
              />
            </Card>
          </FormColumn>
        </FormRow>
        <FormRow>
          <FormColumn>
            <Button
              className="btn arrow"
              onClick={handleNavigation}
              title="Apply Now"
            />
          </FormColumn>
        </FormRow>
        <FormRow>
          <FormColumn>
            <Pagination activeIndex={0} />
          </FormColumn>
        </FormRow>
      </Footer>
      {
        isProgressVisible && <Progress percent={uploadingPercentage} />
      }
    </Transition>
  );
};

LuwaLanding.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  newCheckInAction: PropTypes.func.isRequired,
  newNextAction: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

const mapDispatchToProps = {
  newCheckInAction,
  newNextAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(LuwaLanding);
